export default "/img/FO.617921caeb4da455baeae9b2b9bbe54b.png";